import React, { useEffect } from "react";
import { makeStyles, createStyles, Link } from "@material-ui/core";
import { ITheme } from "../../Layout/themes";
import { loadTicketReceivingData, acceptTicket } from "./actions";
import { connect } from "react-redux";
import { IStoreState } from "../../Store";
import { ThunkDispatch } from "redux-thunk";
import {
  ErrorTypes,
  ShareStatus,
  ITicketReceiveState
} from "../../../interface/IShareInfo";
import { IRemoteAuthData } from "../SignIn/reducer";
import { TicketReceivingContent } from "./TicketReceivingContent";
import { useRouter } from "../../../commons/utils/useRouter";
import { useParams, useLocation } from "react-router-dom";
import { ErrorBarWithChild } from "../../Ui/ErrorBar";

export const commonStaticContentStyles = createStyles({
  headerIcon: {
    fontSize: "8rem",
    display: "block",
    margin: "4rem auto 1.5rem auto"
  },
  headingText: {
    fontSize: "2rem",
    lineHeight: 1.17,
    color: "#414141",
    textAlign: "center",
    marginLeft: "auto",
    marginRight: "auto"
  },
  button: {
    width: 200,
    textTransform: "none",
    fontSize: "1rem",
    fontWeight: "bold",
    boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.1)"
  }
});

const useStyles = makeStyles(({ palette }: ITheme) => {
  return createStyles({
    root: {
      marginBottom: 10
    }
  });
});

interface IProps {
  acceptTicket: () => void;
  loadData: (ticketGroupId: string, ticketId?: string) => void;
  ticketReceivingData: ITicketReceiveState;
  authData: IRemoteAuthData;
}

export const TicketReceivingComponent = ({
  authData,
  loadData,
  acceptTicket,
  ticketReceivingData: { loading, data, error, postStep, firstAccepted }
}: IProps) => {
  const classes = useStyles({});
  const { history } = useRouter();
  const location = useLocation();
  const { token } = authData.data;

  const { ticketGroupId, ticketId } = useParams() as any;

  useEffect(() => {
    if (postStep && token) {
      acceptTicket();
    } else if (ticketGroupId) {
      loadData(ticketGroupId as string, ticketId as string);
    }
  }, [token]);

  useEffect(() => {
    if (
      (data && data.shareStatus === ShareStatus.Init) ||
      (data && data.shareStatus === ShareStatus.Cancelled) ||
      (data && data.shareStatus === ShareStatus.GivenBack) ||
      (error && error.type !== ErrorTypes.ERROR_CODE_409)
    ) {
      history.push(`/status/invalid${location.search}`);
      return;
    }

    if (
      (data && data.shareStatus === ShareStatus.Rejected) ||
      (data && data.shareStatus === ShareStatus.Recalled)
    ) {
      history.push(`/status/declined${location.search}`);
      return;
    }
  }, [data, error]);

  useEffect(() => {
    if (data && data.shareStatus === ShareStatus.Accepted && !firstAccepted) {
      history.push(`/status/accepted${location.search}`);
      return;
    }
  }, [data, firstAccepted]);

  useEffect(() => {
    if (error) {
      window.scroll(0, 0);
    }
  }, [error]);
  let message = <span></span>;
  if(error){
    if(error.type == "409" && authData && authData.data && authData.data.token){
      let token = authData.data.token.replace("Bearer ","");
      let index = location.search.indexOf("mobiUrl=");
      let url = location.search.slice(index + "mobiUrl=".length).replace("&action=accept","")  + "&token=" + token;
      message = <ErrorBarWithChild>
      <span>{error.message}
        <br />
        <Link
            href={url}
            target="_blank"
            rel="noreferrer"
          >Return to your ticket</Link></span>
      </ErrorBarWithChild>
    }
  }
  return (
    <div className={classes.root}>
      {error && message}
      <TicketReceivingContent
        data={data}
        loading={loading}
        authData={authData}
        firstAccepted={firstAccepted}
      />
    </div>
  );
};

const mapStateToProps = (state: IStoreState) => {
  return {
    authData: state.authData,
    ticketReceivingData: state.ticketReceiveData
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {
  return {
    loadData: (ticketGroupId: string, ticketId: string) =>
      dispatch(loadTicketReceivingData(ticketGroupId, ticketId)),
    acceptTicket: () => dispatch(acceptTicket())
  };
};

export const TicketReceiving = connect(
  mapStateToProps,
  mapDispatchToProps
)(TicketReceivingComponent);
